import { on } from '@ngrx/store';

import {
  ManageSurveyActions,
  ManageSurveyApiActions,
} from './manage-survey.actions';
import { ManageSurveyState } from '../survey-state.model';

export const COMMENTS_HANDLERS = [
  on(
    ManageSurveyActions.loadComments,
    (state): ManageSurveyState => ({
      ...state,
      comments: [],
      commentsLoading: true,
      commentsError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.loadCommentsSuccess,
    (state, { comments }): ManageSurveyState => ({
      ...state,
      comments,
      commentsLoading: false,
      commentsError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.loadCommentsFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      comments: [],
      commentsLoading: false,
      commentsError: error,
    }),
  ),
];
